export class ApiResponse {
  status: number;
  message: string;
  exception: string;
  stacktrace: string;
  errors: any;
  domainErrors: Array<string>;
  validation: boolean;
}
